import { BoardItemPermission, BoardItemPermissionParams } from './BoardItemPermission';

export type BoardItemImage = Readonly<{
    width: number
    height: number
    url: string
}>

export type BoardItemParams = Readonly<{
    id: string
    title?: string
    description?: string
    image?: BoardItemImage
    uri?: URL
    permission: BoardItemPermissionParams
    hasPermission: boolean
    publishedAt: Date
}>


export class BoardItem implements BoardItemParams {
    readonly id: string
    readonly title?: string | undefined
    readonly description?: string | undefined
    readonly image?: Readonly<BoardItemImage> | undefined
    readonly uri?: URL
    readonly permission: BoardItemPermission
    readonly hasPermission: boolean
    readonly publishedAt: Date
    
    private constructor(params: BoardItemParams) {
        this.id = params.id
        this.title = params.title
        this.description = params.description
        this.image = params.image
        this.permission = BoardItemPermission.of(params.permission)
        this.hasPermission = this.permission.type === 'all' ? true : params.hasPermission
        this.uri = params.uri
        this.publishedAt = params.publishedAt

        Object.freeze(this)
    }

    static of(params: BoardItemParams): BoardItem {
        if (params instanceof BoardItem) {
            return params
        } else {
            return new BoardItem(params)
        }
    }

    get isSubsOnly(): boolean {
        return this.permission.type === 'subscribers'
    }

    get linkUrl(): string | undefined {
        return this.uri?.toString()
    }

    get domainUrl(): string | undefined {
        return this.uri?.hostname
    }

    changedHasPermission(hasPermission: boolean): BoardItem {
        if (this.hasPermission === hasPermission) {
            return this
        } else {
            return this.copy({ hasPermission })
        }
    }

    private copy(params: Partial<BoardItemParams>): BoardItem {
        return new BoardItem({...this, ...params})
    }
}
